import type { TFunction } from "i18next";
import { getTime } from "../ChatHandler";
import type { Message } from "../ChatInterface";
import type { ChatCampaignFlowSnapshot } from "./UseChatCampaignFlow";
import { getChannelLabelKey, getWhatsAppModeLabelKey } from "./ChatCampaignChoiceConstants";

const getChoiceAnswerKey = (snapshot: ChatCampaignFlowSnapshot): string | null => {
  switch (snapshot.phase) {
    case "channel":
      return getChannelLabelKey(snapshot.channel);
    case "whatsappMode":
      return getWhatsAppModeLabelKey(snapshot.useAi);
    default:
      return null;
  }
};

export const buildChoiceAnswerMessages = (
  snapshot: ChatCampaignFlowSnapshot,
  t: TFunction,
  timestamp = getTime()
): Message[] => {
  const answerKey = getChoiceAnswerKey(snapshot);
  return answerKey ? [{ sender: "user", text: t(answerKey), timestamp, type: "userMessage" }] : [];
};
